import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import moment from 'moment'

export default function HourRange ({ name, ...forwardProps }) {
  const rawDate = useValue(name)

  if (!rawDate) {
    return null
  }

  const date = moment.utc(rawDate)

  return date.format('HH:mm') + ' - ' + date.clone().add(1, 'hour').format('HH:mm')
}
